<template>
  <div id="app" :style="minWidth">  <!--min-width 1024 + navbar 256px-->
    <div v-if="newVersion" class="fc-FFFFFF fs-16 fw-700 center" style="background-color: #1ecc90; padding: 12px 20px 11px;">
      A new version of My Happily is available
      (<span @click.prevent="whatNew" class="cursor-pointer underline">what’s new</span>). 
      <span @click.prevent="refresh" class="cursor-pointer underline">Refresh</span>
    </div>
    <header-menu v-if="logined"></header-menu>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { destroyObjectProperties } from 'highcharts'
import firebase from "firebase/app";
import "firebase/database";
export default {
  name: 'app',
  components: {
    'header-menu': require('./components/main/header').default,
  },
  watch: {
    $route (to, from){
      const noRedirect = [
        "relationship-mapping",
        "reward-message",
        "user-registration",
        "login",
        "pincode",
        "relationship-mapping",
        "setup-wizard"
      ]
      let changeRule = noRedirect.includes(to.name);
      if (this.sideBarStatus == false && !changeRule) {
        this.$router.go(this.$router.currentRoute);
      }
    },
  },
  data () {
    return {
      sideBarStatus: false,
      pagesIgnoreSidebar: {
        "/relationship-mapping": true,
        "/reward-message": true,
        "/user-registration": true,
        "/login": true,
        "/pincode": true,
        "/sso-login": true,
        "/sso-logout": true,
        "/sso-mobile": true,
      },
      pagesMinWidht: {
        "/relationship-mapping": "450px",
        "/reward-message": "auto",
        "/user-registration": "auto",
        "/login": "auto",
        "/pincode": "auto",
        "/sso-login": "auto",
        "/sso-logout": "auto",
        "/sso-mobile": "auto",
      },
      newVersion: false
    }
  },
  beforeCreate(){
    this.$store.commit('demomode/initialiseBlur');
  },
  created () {
    this.$store.dispatch('authen/setUserLogin')
  },
  computed: {
  logined () {
      // if (firebase.auth().currentUser) return true; else return false;
      let userLoged = this.$store.getters['authen/checkLogin'];
      
      if(userLoged) {
         this.$store.dispatch('main/getuser')
         this.$store.dispatch('main/getteam')
      }
      // Pages needed to hide Side bar!
      let pagesHidingSideBar = true;
      let currentPate = this.$router.currentRoute.path;
      if (this.pagesIgnoreSidebar[currentPate]) {
        pagesHidingSideBar = false;
      }
      this.sideBarStatus = pagesHidingSideBar;
      return userLoged && pagesHidingSideBar;
    },
    minWidth () {
      let minWidth = "1024px"; // 1024px, 1280px
      let currentPate = this.$router.currentRoute.path;
      
      if (this.pagesMinWidht[currentPate]) {
        return `min-width: ${this.pagesMinWidht[currentPate]};`;
      }

      return `min-width: ${minWidth};`;
    },
  },
  mounted() {
    this.checkingVersion()
  },
  methods: {
    checkingVersion() {
      let currentPate = this.$router.currentRoute.path;
      let pagesHidingSideBar = true;
      if (this.pagesIgnoreSidebar[currentPate]) {
        pagesHidingSideBar = false;
      }

      if(currentPate=='/pincode'){
         this.newVersion = false;
      }else{
        firebase.database().ref(`version/my_version`).once("value", snapshot => {
        if (snapshot.val()) {
          localStorage.appVersion = snapshot.val()
        }
        if (localStorage.userVersion != localStorage.appVersion && pagesHidingSideBar) {
          this.newVersion = true;
        }

      });
      }
    
    },
    whatNew() {
      window.open('https://www.notion.so/happilyai/What-s-New-8e5a2d8637fe4cedaf80e317ea861000', '_blank');
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion
      location.reload(true);
    }
  }
}
</script>